import React from "react";

type PrintSettingsShellProps = {
  preview: React.ReactNode;
  controls?: React.ReactNode;
  previewLabel?: string;
};

function PrintSettingsShell({
  preview,
  controls,
  previewLabel = "Live Preview",
}: PrintSettingsShellProps) {
  return (
    <div className="print-settings-layout">
      <section className="print-preview-panel">
        <div className="print-panel-header">
          <span className="print-panel-eyebrow">{previewLabel}</span>
          <h2>See changes while editing</h2>
          <p>
            Keep the preview visible and adjust positions from the controls panel
            without scrolling back and forth.
          </p>
        </div>
        <div className="print-preview-panel__body">{preview}</div>
      </section>
      {controls ? (
        <aside className="print-controls-panel">
          <div className="print-panel-header">
            <span className="print-panel-eyebrow">Controls</span>
            <h2>Adjust print elements</h2>
            <p>
              Update the selected layout values here while the print preview stays
              in view.
            </p>
          </div>
          <div className="print-controls-panel__body">{controls}</div>
        </aside>
      ) : null}
    </div>
  );
}

export default PrintSettingsShell;
